import { getOrCreateThread } from './getOrCreateThread/getOrCreateThread';
import { getThreadInfoById } from './getThreadInfoById/getThreadInfoById';
import { getThreadsInfo } from './getThreadsInfo/getThreadsInfo';

export default {
  getOrCreateThread,
  getThreadsInfo,
  getThreadInfoById,
};
